import GoalTracker from '@efdigital/ll-xceed-v2/components/coaching/goal-tracker.gts';
import GoalsList from '@efdigital/ll-xceed-v2/components/coaching/goals-list.gts';
import type { CoachingCoachCoacheesCoacheeGoalsModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee/goals';
import { accessibleScrollBehavior } from '@efdigital/ll-xceed-v2/utils/application/scroll';
import { array } from '@ember/helper';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachCoacheesCoacheeGoalsSignature {
  Args: {
    model: CoachingCoachCoacheesCoacheeGoalsModel;
    controller: unknown;
  };
}

export default class CoachingCoachCoacheesCoacheeGoals extends Component<CoachingCoachCoacheesCoacheeGoalsSignature> {
  @service declare router: RouterService;
  @tracked showCreateForm = false;

  get isGoalDetail(): boolean {
    return (
      this.router.currentRouteName ===
      'coaching.coach.coachees.coachee.goals.goal'
    );
  }

  get canAddGoal(): boolean {
    return Boolean(this.args.model.defaultPlan);
  }

  revealCreateForm = () => {
    this.showCreateForm = true;
    window.setTimeout(() => this.focusCreateForm(), 0);
  };

  hideCreateForm = () => {
    this.showCreateForm = false;
  };

  focusCreateForm = () => {
    document.getElementById('goal-create')?.scrollIntoView({
      behavior: accessibleScrollBehavior(),
      block: 'start',
    });
    document.getElementById('goal-create-title')?.focus();
  };

  <template>
    {{#if this.isGoalDetail}}
      {{outlet}}
    {{else}}
      {{pageTitle "Goals"}}

      <GoalTracker
        @goals={{@model.goals}}
        @milestones={{@model.milestones}}
        @canAddGoal={{this.canAddGoal}}
        @onAddGoals={{this.revealCreateForm}}
        @role="coach"
      />

      <GoalsList
        @goals={{@model.goals}}
        @milestones={{@model.milestones}}
        @plan={{@model.defaultPlan}}
        @ownerUserId={{@model.coachee.coacheeUserId}}
        @role="coach"
        @goalRoute="coaching.coach.coachees.coachee.goals.goal"
        @goalRouteModels={{array @model.coachee.coacheeUserId}}
        @showCreateForm={{this.showCreateForm}}
        @onGoalCreated={{this.hideCreateForm}}
        @onCloseCreateForm={{this.hideCreateForm}}
      />
    {{/if}}
  </template>
}
